import { render, staticRenderFns } from "./zoomable.vue?vue&type=template&id=0ddabcd6"
import script from "./zoomable.vue?vue&type=script&lang=js"
export * from "./zoomable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports